/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import ViewAllRoles from '../../ViewAllRoles';
import { dataService } from '../../../services/data.services';
import { Link, useParams } from 'react-router-dom';
import ViewStaffShimmer from '../../Shimmer/ViewStaffShimmer';
import { CognitoData } from '../../../CommonMethods/CognitoData';
import CardHeader from '../../CardHeader';
import { useNavigate } from 'react-router-dom';
import FormatDateString from '../../../CommonMethods/FromatDateString';
import GlobalContext from '../../Context/GloablContext';

const ViewStaff = ({userType, ApiType}) => {
    const urlParams = new URLSearchParams(window.location.search);
    const { rolesGlobal, isInactiveBranch } = useContext(GlobalContext)
    const [getRecodes, setGetRecodes] = useState({})
    const [userRole,setUserRole]=useState("")
    const [loading, setLoading] = useState(true);
    const {id} = useParams();
    const [staffClasses, setStaffClasses]  = useState([]);
    const location = useNavigate();
    const getUserData = async() => {
        try{
            const user = await CognitoData();
            setUserRole(user.idToken.payload["custom:user_type"])
            if(ApiType === "cognito"){
                const user = await CognitoData();
                let rolesArray = rolesGlobal || user.idToken.payload["cognito:groups"];
                const anyCollectFeeRoleExists = rolesArray.some(role => role.startsWith("collect-fee"));
                const rolesArray1 = ((rolesArray.includes("collect-fee") && !anyCollectFeeRoleExists) ||
                    rolesArray.includes("collect-fee") && rolesArray.includes("collect-fee:receipt"))
                    ? [...rolesArray, "collect-fee:receipt"]
                    : rolesArray;

                setGetRecodes({
                    roles: rolesArray1, 
                    employee_number:user.idToken.payload["custom:employee_number"],
                    status:user.idToken.payload["custom:status"],
                    first_name : user.idToken.payload["name"],
                    last_name : user.idToken.payload["middle_name"],
                    email_address : user.idToken.payload["email"],
                    mobile_number : user.idToken.payload["phone_number"].split('+91')[1],
                });
            } else {
                let res = await dataService.GetAPI(`users/${id}`, true);
                if(res?.data?.data) {
                    let data = res.data.data.data;
                    let rolesArray = res.data.data.data.roles || [];
                    const anyCollectFeeRoleExists = rolesArray.some(role => role.startsWith("collect-fee"));
                    const rolesArray1 = ((rolesArray.includes("collect-fee") && !anyCollectFeeRoleExists) ||
                        rolesArray.includes("collect-fee") && rolesArray.includes("collect-fee:receipt"))
                        ? [...rolesArray, "collect-fee:receipt"]
                        : rolesArray;
                    data.roles = rolesArray1;
                    setGetRecodes((prevState) => ({ ...prevState, ...data }));
                    setStaffClasses((prevState) => ([ ...prevState, ...res.data.data.classes ]));
                }
            }
            setLoading(false) 
        } catch(error){
            location('/404')
        }

    }
    useEffect(() => {
        getUserData()
    }, [rolesGlobal])

    const formatPhoneNumber = (phoneNumber) => {
        const numericOnly = phoneNumber.replace(/\D/g, '');
        if (numericOnly?.length === 10) {
            return numericOnly.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
        } else {
            return phoneNumber;
        }
    };

    const onEditHandler=()=>{
        location(`/employee-master/manage-employee/edit-staff/${getRecodes?.email_address}`, {state: {redirect: 'fromViewScreen'}});
    }

    return (

        <CardHeader noPadding>

            <div class="mainDataCntnrTop shadow-s13 flex items-center">
                {ApiType === "cognito" ? <h5 class="pageHeader cursor-pointer">My Profile</h5>
                    : <Link to={`/employee-master/manage-employee?${urlParams.toString()}`}>
                        <div className='flex flex-row justify-between items-center w-full'>
                            <div className='flex items-center'>
                                <a href="javascript:void(0)" onClick={()=>location(`/employee-master/manage-employee?${urlParams.toString()}`)}>
                                    <img loading="lazy" decoding="async" src="/images/back-btnBlue.svg" alt="icon" />
                                </a>
                                <h5 class="pageHeader ml-2.5 adderror">Employee Details</h5>
                            </div>
                        </div>
                    </Link>}
                {ApiType !== 'cognito' ?
                    <>
                        {!isInactiveBranch && localStorage.getItem('email') !== getRecodes.email_address &&
                            <div className='flex items-center'>
                                <button class="view-actn-btn" onClick={onEditHandler}>
                                    Edit
                                </button>
                            </div>}
                    </> : <>
                        <Link to={`/profile/update-password`}
                            className={`view-actn-btn`}>
                            Update Password
                        </Link>
                    </>
                }
            </div>
            {loading ? <div className='mainDataCntnrPageDiv'><ViewStaffShimmer /></div> : <>
                {ApiType === "cognito" ? 
                    <div class="mainDataCntnrPageDiv scrollBlue_thick ">
                        <div className='flex justify-between items-center border border-[#C2DCEF] p-[16px] rounded w-[90%] mx-auto'>
                            <div className='-mx-2 flex w-full'>
                                <div className='w-[50%] px-2 pr-6'>
                                    {(userRole!=='institution-user'&&userRole!=='institution-admin')&&<div className='flex items-start mb-4'>
                                        <div className='flex items-center'>
                                            <p className="text-f7 font-normal text-[#031624] min-w-[160px]">Employee Number</p>
                                            <p className='text-f7 font-semibold text-[#031624]'>{getRecodes?.employee_number || '- '}</p>
                                        </div>
                                        <span className='ml-4 mt-[-3px]'><div className={`rounded  ${getRecodes?.status ? 'bg-[#C5FFD5]' : 'bg-[#E6E8EA]'} flex items-center justify-center ml-6 py-1 px-2.5`}>
                                            <img loading="lazy" decoding="async" src={getRecodes?.status ? "/images/successDot.svg" : "/images/inactive-Dot.svg" } alt="icon"/>
                                            <span className="text-f7 font-normal text-[#031624] pl-1">{getRecodes?.status ? 'Active' : 'Inactive'}</span>
                                        </div></span>
                                    </div>}
                                    <div className='flex items-start'>
                                        <div className={`flex items-center ${userRole==='institution-user'||userRole==='institution-admin?"mt-[1.8px]":"mt-[16px]"'}`}>
                                            <p className={`text-f7 font-normal text-[#031624] ${userRole!=='institution-user'&&userRole!=='institution-admin' ? 'min-w-[160px]':'min-w-[120px]'}  mt-2`}>Full Name</p>
                                            <p className='text-f7 font-semibold text-[#031624] mt-2'>{getRecodes?.first_name} {getRecodes?.last_name}</p>

                                        </div>
                                        {(userRole==='institution-user'||userRole==='institution-admin')&&
                                        <span className='ml-4 mt-[-3px]'><div className={`rounded  ${getRecodes?.status ? 'bg-[#C5FFD5]' : 'bg-[#E6E8EA]'} flex items-center justify-center ml-6 mt-2 py-1 px-2.5`}>
                                            <img loading="lazy" decoding="async" src={getRecodes?.status ? "/images/successDot.svg" : "/images/inactive-Dot.svg" } alt="icon"/>
                                            <span className="text-f7 font-normal text-[#031624] pl-1">{getRecodes?.status ? 'Active' : 'Inactive'}</span>
                                        </div></span>}
                                    </div>
                                </div>
    
                                <div className='w-[50%] px-2 '>
                                    <div className='flex items-center justify-start '>
                                        <div className='flex items-center'>
                                            <p className="text-f7 font-normal text-[#031624] min-w-[160px]">Email Address</p>
                                            <p className='text-f7 font-semibold text-[#031624] justify-center break-all'>{getRecodes?.email_address}</p>
                                        </div>
                                    </div>
                                    <div className='flex items-center  mt-[16px]'>
                                        <p className='text-f7 font-normal text-[#031624] min-w-[160px]'>Mobile Number</p>
                                        <p className='text-f7 font-semibold text-[#031624]'>{formatPhoneNumber(getRecodes?.mobile_number)}</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="overflow-x-hidden overflow-y-auto scrollBar-hidden mx-auto mt-[30px] mx-auto w-[90%]">
                            <p class="text-lg font-semibold text-[#000000] mb-2">Roles</p>
                            <ViewAllRoles selectedRoles={getRecodes.roles} userTypeVal={userType === "institution-admin" && ApiType === "cognito" ? true : false}/>
                        </div>
                    </div>: <div class="mainDataCntnrPageDiv scrollBlue_thick">
                        <div class=" px-[30px]">
                            <div class="w-[80%] mx-auto">
                                <div className='w-full border border-[#D0D5DD] rounded p-3 mb-4'>
                                    <div className='-mx-2 flex w-full'>
                                        <div className='w-[50%] px-2 pr-6'>
                                            <div className='flex justify-items-start mb-4'>
                                                <div className='flex items-start justify-between'>
                                                    <p className="text-f7 font-normal text-[#031624] min-w-[160px]">Employee Number</p>
                                                    <p className='text-f7 font-semibold text-[#031624] justify-center break-all'>{getRecodes?.employee_number || '- '}</p>
                                                </div>                                                
                                                <span className=''><div className={`rounded ${getRecodes?.status ? 'bg-[#C5FFD5]' : 'bg-[#E6E8EA]'} flex items-center justify-center ml-6 py-1 px-3 relative top-[-6px]`}>
                                                    <img loading="lazy" decoding="async" src={getRecodes?.status ? "/images/successDot.svg" : "/images/inactive-Dot.svg" } alt="icon"/>
                                                    <span className="text-f7 font-normal text-[#031624] pl-1">{getRecodes?.status ? 'Active' : 'Inactive'}</span>
                                                </div></span>
                                            </div>
                                            <div className='flex justify-items-start mb-4'>
                                                <div className={`flex items-center ${userRole==='institution-user'||userRole==='institution-admin?"mt-[1.8px]":"mt-[16px]"'}`}>
                                                    <p className='text-f7 font-normal text-[#031624] min-w-[160px]'>First Name</p>
                                                    <p className='text-f7 font-semibold text-[#031624] break-all'>{getRecodes?.first_name}</p>
                                                </div>
                                            </div>
                                            <div className='flex justify-items-start mb-4'>
                                                <div className={`flex items-center ${userRole==='institution-user'||userRole==='institution-admin?"mt-[1.8px]":"mt-[16px]"'}`}>
                                                    <p className='text-f7 font-normal text-[#031624] min-w-[160px]'>Last Name</p>
                                                    <p className='text-f7 font-semibold text-[#031624] break-all'>{getRecodes?.last_name}</p>
                                                </div>
                                            </div>
                                        </div>
            
                                        <div className='w-[50%] px-2 '>
                                            <div className='flex justify-items-start mb-4'>
                                                <div className='flex items-start justify-between'>
                                                    <p className="text-f7 font-normal text-[#031624] min-w-[160px]">Email Address</p>
                                                    <p className='text-f7 font-semibold text-[#031624] justify-center break-all'>{getRecodes?.email_address}</p>
                                                </div>
                                            </div>
                                            <div className='flex justify-items-start mb-4'>
                                                <p className='text-f7 font-normal text-[#031624] min-w-[160px]'>Mobile Number</p>
                                                <p className='text-f7 font-semibold text-[#031624]'>{formatPhoneNumber(getRecodes?.mobile_number)}</p>

                                            </div>
                                            {getRecodes?.staff_type && <div className='flex justify-items-start mb-4'>
                                                <div className='flex items-center justify-between'>
                                                    <p className="text-f7 font-normal text-[#031624] min-w-[160px]">Type</p>
                                                    <p className='text-f7 font-semibold text-[#031624] justify-center break-all'>{getRecodes?.staff_type}</p>
                                                </div>
                                            </div>}
                                            <div className='flex justify-items-start mb-4'>
                                                <div className='flex items-center'>
                                                    <p className="text-f7 font-normal text-[#031624] min-w-[160px]">Last Login</p>
                                                    <p className='text-f7 font-semibold text-[#031624] justify-center break-all'>{getRecodes?.is_first_time_login ? '-' :  FormatDateString(getRecodes?.last_login_at)}</p>
                                                </div>
                                            </div>
                                            <hr></hr>
                                            <div className='flex justify-items-start mb-4 mt-4'>
                                                <div className='flex items-center'>
                                                    <p className="text-f7 font-normal text-[#031624] min-w-[160px]">Created on {FormatDateString(getRecodes?.created_at)} by {getRecodes?.created_by}</p>
                                                </div>
                                            </div>
                                            <div className='flex justify-items-start'>
                                                <div className='flex items-center'>
                                                    <p className="text-f7 font-normal text-[#031624] min-w-[160px]">Last Updated on {FormatDateString(getRecodes?.updated_at)} by {getRecodes?.created_by}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            {staffClasses?.length !== 0 && <div className='flex justify-center  px-[30px] mt-5 overflow-x-hidden overflow-y-auto scrollBar-hidden'>
                                <div class="flex justify-start 2xl:w-[80%] w-[85%] mx-auto border border-[#D0D5DD] rounded">
                                    <p className="text-f7 p-2 font-normal text-[#031624] min-w-[180px]">Associated Class(es)</p>
                                    <div className='flex flex-wrap '>
                                        {staffClasses?.map((item)=>(
                                            <div className=' p-2' key={item._id}>
                                                <p className="text-f7 font-semibold text-[#031624] w-full">{item.class_name}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>}
                        </div>
                        <div class=" px-[30px] mt-5 ">
                            <div class="w-[80%] overflow-x-hidden overflow-y-auto scrollBar-hidden mx-auto mt-[30px] mx-auto">
                                <p class="text-lg font-semibold text-[#000000] mb-2">Roles</p>
                                <ViewAllRoles selectedRoles={getRecodes.roles} userTypeVal={userType === "institution-admin" && ApiType === "cognito" ? true : false} userType={userType} />
                            </div>
                        </div>
                    </div> }
            </>}
        </CardHeader>  );
}

export default ViewStaff;
